/**
 * Short role labels for dentist calendar surfaces that list multiple shifts
 * (JobSelectionModal, DentistJobsForDatePage, legacy F7 home modal).
 *
 * Job.type: 0 Hygienist, 1 Assistant, 2 Reception/Admin
 * T2-6764: type 2 must not fall through to "Hygienist".
 */
export const getDentistShiftRoleLabel = (jobType: number | string | null | undefined): string => {
  if (jobType === null || jobType === undefined || jobType === '') return 'Dental Professional';
  switch (Number(jobType)) {
    case 0:
      return 'Hygienist';
    case 1:
      return 'Assistant';
    case 2:
      return 'Dental Reception/Admin';
    default:
      return 'Dental Professional';
  }
};

/** Full role label for single-shift detail and invoice surfaces. */
export const getDentistShiftRoleLongLabel = (jobType: number | string | null | undefined): string => {
  if (jobType === null || jobType === undefined || jobType === '') return 'Dental Professional';
  switch (Number(jobType)) {
    case 0:
      return 'Dental Hygienist';
    case 1:
      return 'Dental Assistant';
    case 2:
      return 'Admin/Reception';
    default:
      return 'Dental Professional';
  }
};
